import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { APPOINTMENT_STATUS } from '@/types/appointment';
import { createThemedStyles } from '@/hooks/use-theme-colors';

const useConfig = createThemedStyles<
  Record<
    APPOINTMENT_STATUS,
    { label: string; color: string; bg: string; icon: keyof typeof Ionicons.glyphMap }
  >
>((th) => ({
  [APPOINTMENT_STATUS.PENDING]: {
    label: 'Pendente',
    color: th('#B45309'),
    bg: th('#FFFBEB'),
    icon: 'hourglass-outline',
  },
  [APPOINTMENT_STATUS.CONFIRMED]: {
    label: 'Confirmado',
    color: th('#047857'),
    bg: th('#ECFDF5'),
    icon: 'checkmark-circle-outline',
  },
  [APPOINTMENT_STATUS.COMPLETED]: {
    label: 'Concluído',
    color: th('#525252'),
    bg: th('#F5F5F5'),
    icon: 'flag-outline',
  },
  [APPOINTMENT_STATUS.CANCELLED]: {
    label: 'Cancelado',
    color: th('#B91C1C'),
    bg: th('#FEF2F2'),
    icon: 'close-circle-outline',
  },
  [APPOINTMENT_STATUS.NO_SHOW]: {
    label: 'Faltou',
    color: th('#B91C1C'),
    bg: th('#FEF2F2'),
    icon: 'alert-circle-outline',
  },
}));

export function AppointmentStatusPill({ status }: { status: APPOINTMENT_STATUS }) {
  const CONFIG = useConfig();
  const cfg = CONFIG[status] ?? CONFIG[APPOINTMENT_STATUS.COMPLETED];
  return (
    <View
      className="flex-row items-center gap-1.5 self-start rounded-full px-2.5 py-1"
      style={{ backgroundColor: cfg.bg }}
    >
      <Ionicons name={cfg.icon} size={12} color={cfg.color} />
      <ThemedText className="font-semibold text-xs" style={{ color: cfg.color }}>
        {cfg.label}
      </ThemedText>
    </View>
  );
}
